import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/services/alert.service';
import { ActividadesService } from '../../services/actividades.service';
import { PlanAccionService } from '../../services/plan.accion.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { ActividadesInterface } from '../../models/actividades';
import { Objetivo } from '../../models/objetivo';
import { ModalService } from 'src/app/services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { DatePipe } from '@angular/common';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { ConstantsCatalogosIdService } from './../../../../services/constants-catalogos-id.service';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-actividad',
  templateUrl: './actividad.component.html',
  styleUrls: ['./actividad.component.css']
})
export class ActividadComponent {
  public listaActividadesN5: any = [];
  public mostrarModal: boolean = false;
  public dataPlanAccionN5!: any;
  public dataObjetivoN5!: any;
  public formSubmitted = false;
  public formActividad!: FormGroup;
  public formActividadCumple!: FormGroup;
  public ipAddress: any;
  buffer!: any;
  currentUser!: any;
  nameUnidad!: any;
  public idSprAmbiente: any;
  public nombreObjetivo!: any;
  dataSource: any = [];

  dtOptions: DataTables.Settings = {};
  isDtInitialized: boolean = false;
  dtElement: DataTableDirective;
  dtTrigger: Subject<any> = new Subject<any>();
  private idDeleteRegister: number = 0;
  public modalActividades: string = 'modalActivities';
  public modalCumpleActividades: string = 'modalCumpleActivities';

  nameActivadades = 'ACTIVIDADES'; //LINEA ACCION
  nameActivadadesPlanes = 'ACTIVIDADES';//PLANES ACCION
  public selectItems: any[] = [];
  public selectItems1: any[] = [];
  public pesoRestante: number = 100;
  public pesoEdit: any = 0;
  public pesoTotalEditado: any = 0;
  editPorcentajeTotal: boolean = true;
  editPorcentaje: boolean = false;
  public desahabilitarForm: boolean = false;
  public idActividad: number = 0;
  public nameLineaAccion: any;
  public namePlanAccion: any;
  public nombreElemento: any
  public idSprNivel: number = 0;
  public nombre: any;
  public fechaComprometida: any;
  public fechaInicio: any;
  public tipoAccion: any;
  public peso: any;
  public cumplimiento: any;
  public estado: any;
  pipe = new DatePipe('en-US');
  hoy = new Date();
  public fechaInicioLinea: any;
  public fechaFinLinea: any;
  public habilitarCumplimiento: boolean = false;
  public idSprNivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5;

  @ViewChild('myInput')
  myInputVariable: ElementRef;


  @Input() set lineaAccionInput(lineaAccionInput2: any){
    this.dataSource = lineaAccionInput2;
    this.nameLineaAccion = lineaAccionInput2.nombreLineaAccion;
    this.nombreElemento = lineaAccionInput2.nombreElemento;
    this.fechaInicioLinea = lineaAccionInput2.fechaInicio;
    this.fechaFinLinea = lineaAccionInput2.fechaFin;
    if (lineaAccionInput2) {
      this.getActividades();
    }
  }

  @Input() set planAccionInput(planAccionInput: any)  {
    this.dataSource = planAccionInput;
    this.namePlanAccion = planAccionInput.nombrePlanAccion
    this.nombreElemento = planAccionInput.nombreElemento
    this.fechaInicioLinea = planAccionInput.fechaInicio;
    this.fechaFinLinea = planAccionInput.fechaFin;
    if (planAccionInput) {
      this.getActividades();
    }
  }

  readonly constant = ConstantsCatalogosIdService;
  constructor(
    private actividadesService: ActividadesService,
    private planAccionservice: PlanAccionService,
    private alertService: AlertService,
    private fb: FormBuilder,
    private ip: IpPublicService,
    public modal: ModalService,
    private sanitizer: DomSanitizer,
    private store: Store<AppState>,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.nameUnidad = localStorage.getItem('nameUnidad');
    this.currentUser = JSON.parse(this.buffer);
    this.getDataPlanesAccionN5();
    this.getDataObjetivo();

    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.selectItems1 = [
      { value: 1, label: 'Completado' },
      { value: 2, label: 'No Completado' },
    ];
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe((response) => {
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
    });
    this.getIpPublic();
    this.initApp();
  }

  initApp() {
    this.setDataTable();
    this.setForm();
    this.getDataPlanesAccionN5();
    this.getDataObjetivo();
    this.getActividades();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  reDrawDataTable() {
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }
  habilitarForm() {
    this.desahabilitarForm = true
  }

  setForm() {
    this.formActividad = this.fb.group({
      idSprActividad: [],
      idSprLineaAccion: [],
      idSprPlanAccion: [],
      nombre: ['', [Validators.required]],
      fechaComprometida: ['', [Validators.required, validadorFechaIntervalo(this.fechaInicioLinea, this.fechaFinLinea)]],
      fechaInicio: [this.pipe.transform(this.hoy, 'yyyy-MM-dd')],
      peso: ['', [Validators.required]],
      //cumplimiento: [],
      //respaldo: [],
      estado: [1, [Validators.required]],
    });

    this.formActividadCumple = this.fb.group({
      idSprActividad: [],
      idSprLineaAccion: [],
      idSprPlanAccion: [],
      cumplimiento: [],
      respaldo: ['', [Validators.required]],
      estado: [1, [Validators.required]],
    });
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  getActividades() {

    if (this.dataSource.idSprLineaAccion) {
      this.actividadesService
        .list('?idSprLineaAccion=' + this.dataSource.idSprLineaAccion)
        .subscribe((listaActividades) => {
          this.listaActividadesN5 = listaActividades;

          this.calculo(this.listaActividadesN5, this.pesoRestante);// envia parametros para realizar el cálculo
        });
    } else {
      this.actividadesService
        .list('?idSprPlanAccion=' + this.dataSource.idSprPlanAccion)
        .subscribe((listaActividades) => {
          this.listaActividadesN5 = listaActividades;
          this.calculo(this.listaActividadesN5, this.pesoRestante);
        });
    }
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  filtrarActividades(listaActividades: any, obj: any) {
    if (obj.idSprLineaAccion) {
      return listaActividades.filter((actividad: any) => {
        return actividad.idSprLineaAccion === obj.idSprLineaAccion;
      });
    } else {
      return listaActividades.filter((actividad: any) => {
        return actividad.idSprPlanAccion === obj.idSprPlanAccion;
      });
    }
  }
  validacionFechas(fecha1: Date, fecha2: Date) {
    let alerta1
    if (fecha1 > fecha2) {
      alerta1 = this.alertService.warning(
        '¡Atención!',
        'La fecha inicial no puede ser mayor a la fecha de cumplimiento'
      );
    }
  }

  validacionPeso(peso: any, pesoRestante: any, pesoTotalEdit: any) {
    if (this.formActividad.value.idSprActividad == null) {
      if (peso > pesoRestante) {
        if (pesoRestante > 0) {
          this.alertService.warning(
            '¡Atención!',
            'Peso seleccionado debe ser menor o igual que: ' + pesoRestante + '%',
          );
        }
        if (pesoRestante <= 0) {
          this.alertService.warning(
            '¡Atención!',
            'El peso de las actividades ya cumplen el 100 % ',
          );
        }
      } else if (peso == 0) {
        this.alertService.warning(
          '¡Atención!',
          'Peso seleccionado no puede ser 0% ',
        );
      }
    } else {
      if (peso > pesoTotalEdit) {
        this.alertService.warning(
          '¡Atención!',
          'Peso seleccionado debe ser menor o igual que : ' + pesoTotalEdit + '%',
        );
      }
      else if (peso == 0) {
        this.alertService.warning(
          '¡Atención!',
          'Peso seleccionado no puede ser 0% ',
        );
      }
    }
    return
  }

  onSubmit() {
    this.formSubmitted = true;
    if (this.dataSource.idSprLineaAccion) {
      this.formActividad.value.idSprLineaAccion = this.dataSource.idSprLineaAccion;
    } else {
      this.formActividad.value.idSprPlanAccion = this.dataSource.idSprPlanAccion;
    }
    this.formActividad.value.usuario = this.currentUser.idSprUsuario;
    this.formActividad.value.ip = this.ipAddress;
    let fechaComprometida = this.formActividad.value.fechaComprometida;
    let FechaCumplimiento = this.formActividad.value.fechaInicio;
    let peso = this.formActividad.value.peso;
    let pesoTotalEdit = this.pesoTotalEditado
    let pesoRestante = this.pesoRestante

    this.validacionPeso(peso, pesoRestante, pesoTotalEdit)
    if (this.formActividad.valid) {
      if (this.formActividad.value.idSprActividad == null && (peso <= pesoRestante) && (peso != 0)) {
        this.formActividad.value.fechaComprometida = fechaComprometida;
        this.formActividad.value.fechaInicio = FechaCumplimiento;
        this.actividadesService.create(this.formActividad.value)
          .subscribe(
            (resp) => {
              this.initApp();
              this.closeModalActividad()
              this.modal.closeId(this.modalCumpleActividades);
              this.alertService.createOk();
              this.editPorcentajeTotal = true;
              this.editPorcentaje = false;
            },
            (err) => {
              //this.alertService.createError();
            }
          );
      } else
        if ((peso <= pesoTotalEdit) && (peso != 0)) {
          this.actividadesService.update(this.formActividad.value)
            .subscribe(
              (resp) => {
                this.initApp();
                this.closeModalActividad();
                this.modal.closeId(this.modalCumpleActividades);
                this.alertService.updateOk();
                this.editPorcentajeTotal = true;
                this.editPorcentaje = false;
              },
              (err) => {
                //this.alertService.createError();
              }
            );
        }

    } else {

      return;
    }
  }

  cumpleActividad() {

    if (this.dataSource.idSprLineaAccion) {
      this.formActividad.value.idSprLineaAccion = this.dataSource.idSprLineaAccion;
    } else {
      this.formActividad.value.idSprPlanAccion = this.dataSource.idSprPlanAccion;
    }

    if (this.formActividad.value.idSprActividad != null) {
      this.formActividad.value.respaldo = this.nameFileGuardado;
      this.formActividad.value.cumplimiento = 1;
      this.actividadesService.update(this.formActividad.value)
        .subscribe(
          (resp) => {
            this.initApp();
            this.closeModalCumpleActividad();
            //this.modal.closeId(this.modalCumpleActividades);
            this.alertService.updateOk('!Correcto!','Actividad cumplida correctamente.'
            );
            this.editPorcentajeTotal = true;
            this.editPorcentaje = false;
          },
          (err) => {
            //this.alertService.createError();
          }
        );
    }

  }

  updateActividades(obj: ActividadesInterface) {
    this.editPorcentajeTotal = false;
    this.editPorcentaje = true;
    this.openModalActividad();
    this.formActividad.patchValue({
      idSprActividad: obj.idSprActividad,
      idSprPlanAccion: obj.idSprPlanAccion,
      nombre: obj.nombre,
      fechaComprometida: obj.fechaComprometida,
      fechaInicio: obj.fechaInicio,
      peso: obj.peso,
      cumplimiento: obj.cumplimiento,
      respaldo: obj.respaldo,
      estado: obj.estado,
    });
    this.pesoEdit = obj.peso;
    this.pesoTotalEditado = (this.pesoRestante + this.pesoEdit);
  }

  evaluacionActividades(obj: ActividadesInterface) {
    this.formSubmitted = true;
    let fechaComprometidaVal;
    let fechaActual;
    fechaComprometidaVal = obj.fechaComprometida;
    fechaActual = this.pipe.transform(this.hoy, 'yyyy-MM-dd');

    if (this.listaActividadesN5.length >= 3) {
      if (this.pesoRestante <= 0) {
        if (fechaComprometidaVal >= fechaActual) {
          this.openModalCumpleActividad();
        } else {
          this.alertService.warning('¡Atención!', 'Fecha comprometida fuera de vigencia.')
        }



        this.formActividad.patchValue({
          idSprActividad: obj.idSprActividad,
          idSprPlanAccion: obj.idSprPlanAccion,
          nombre: obj.nombre,
          fechaComprometida: obj.fechaComprometida,
          fechaInicio: obj.fechaInicio,
          peso: obj.peso,
          cumplimiento: obj.cumplimiento,
          respaldo: obj.respaldo,
          estado: obj.estado,
        });
        this.pesoEdit = obj.peso;
        this.pesoTotalEditado = (this.pesoRestante + this.pesoEdit);
        this.idActividad = obj.idSprActividad,
          this.nombre = obj.nombre,
          this.fechaComprometida = obj.fechaComprometida,
          this.fechaInicio = obj.fechaInicio,
          this.peso = obj.peso,
          this.cumplimiento = obj.cumplimiento,
          this.estado = obj.estado
      } else {
        this.alertService.warning('¡Atención!',
          'La suma de los pesos debe ser igual al 100 %')
      }
    } else {
      this.alertService.warning('¡Atención!',
        'Ingreso de TRES ACTIVIDADES como mínimo')
      return;
    }


  }

  getDataPlanesAccionN5() {
    this.planAccionservice.list().subscribe((resp) => {
      this.dataPlanAccionN5 = resp;

    });
  }

  getDataObjetivo() {
    this.planAccionservice.list().subscribe((resp) => {
      this.dataObjetivoN5 = resp;

    });
  }

  deleteActividades(idRegister: number) {
    this.modal.open('deleteActivities');
    this.idDeleteRegister = idRegister;
  }
  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.actividadesService.delete(
        {
          idSprActividad: this.idDeleteRegister,
          usuario: this.currentUser.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            //this.getActividades();
            this.alertService.deleteOk();
            this.initApp();
            this.modal.closeId('deleteActivities');
          },
          (err) => {
            this.alertService.deleteError();
          }
        );
    }
  }

  calculo(dataActividades: any, pesoRestante: number) {
    let ponderacionTotalActividad: any = 100;
    let pesoAterior: any = 0;
    let pesoActual: any;
    let ponderacionRestante: any = 100;
    for (let i = 0; i < dataActividades.length; i++) {
      pesoActual = dataActividades[i].peso
      pesoAterior = (pesoActual + pesoAterior);
      ponderacionRestante = (ponderacionTotalActividad - pesoAterior);
    }
    this.pesoRestante = ponderacionRestante;
    this.pesoTotalEditado = (this.pesoRestante + this.pesoEdit);
  }

  getNombreObjetivo(id: number, objetivos: Objetivo[]) {
    return objetivos.filter((objetivo) => {
      return objetivo.idSprObjetivo === id;
    });
  }

  /* ################################################# */
  /*******función subir archivo *********************/
  /* ################################################# */
  public archivos: any = [];
  public nameFileGuardado: any;
  public previsualizacion: string;

  visualizarPdf(archivo: string) {
    this.actividadesService.download(archivo).subscribe({
      next: (data) => {
        const byteCharacters = atob(data.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
           const fileURL = URL.createObjectURL(blob);
           //window.open(fileURL, '_black');
           FileSaver.saveAs(blob, archivo +'.pdf');
      },
      error: () => {

      }
    })
  }

  extraerBase64 = async ($event) => new Promise((resolve, reject) => {
    try {
      const unsafeIng = window.URL.createObjectURL($event);
      const image = this.sanitizer.bypassSecurityTrustUrl(unsafeIng);
      const reader = new FileReader();
      reader.readAsDataURL($event);
      reader.onload = () => {
        resolve({
          //blob: $event,
          //image,
          base: reader.result
        });
      };
      reader.onerror = error => {
        resolve({
          //blob: $event,
          //image,
          base: null
        });
      };

    } catch (error) {
      return null;
    }
  })
  capturarFile(event): any {
    this.formSubmitted = false;
    const archivoCapturado = event.target.files[0];
    this.extraerBase64(archivoCapturado).then((imagen: any) => {
      this.previsualizacion = imagen.base;

    }
    );
    this.archivos.push(archivoCapturado);

  }

  subirArchivo(): any {
    this.formSubmitted = true;

    if (this.archivos.length != 0) {
      try {
        const formularioDeDatos = new FormData();
        this.archivos.forEach(archivo => {
          formularioDeDatos.append('file', archivo);
        })

        this.actividadesService.postArchivo(formularioDeDatos, this.idActividad).subscribe(responseNamePdf => {
          this.nameFileGuardado = responseNamePdf.filename;
          this.cumpleActividad()
        }
        )
      } catch (error) {

      }

    } else {
      this.alertService.warning('¡Atención!', 'No existe documento de soporte')
      return;
    }
  }

  openModalActividad() {
    this.modal.open(this.modalActividades);
    this.onResetForm();
    this.setForm();
    this.getActividades();
  }

  closeModalActividad() {
    this.modal.closeId(this.modalActividades);
    this.setDataTable();
    this.setForm();
    this.getActividades();
    this.editPorcentajeTotal = true;
    this.editPorcentaje = false;
  }

  openModalCumpleActividad() {
    this.formSubmitted = false;
    this.formActividad.reset();
    this.modal.open(this.modalCumpleActividades);
    this.setForm();
    //this.formActividad.value.respaldo.reset();

  }

  closeModalCumpleActividad() {
    //this.formSubmitted = false;  
    //this.archivos = [] 
    this.reset();
    this.modal.closeId(this.modalCumpleActividades);
  }
  reset() {
    this.myInputVariable.nativeElement.value = "";
    this.archivos = []
  }

  closeModal() {
    this.modal.close();
  }

  closeModalEliminar() {
    this.modal.closeId('deleteActivities');
  }

  onResetForm() {
    this.formSubmitted = false;
    this.formActividad.reset();
    this.formActividad.patchValue({
      ...this.formActividad.value,
      estado: 1
    })

  }
}
